import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomThickPlus({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19 9.5h-8.5V1a.5.5 0 00-1 0v8.5H1a.5.5 0 000 1h8.5V19a.5.5 0 001 0v-8.5H19a.5.5 0 000-1z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeWidth={0.75}
      />
    </svg>
  );
}
export default SvgIconCustomThickPlus;
